import { render, staticRenderFns } from "./MagazinePuzzles.vue?vue&type=template&id=71295a7c&scoped=true"
import script from "./MagazinePuzzles.vue?vue&type=script&lang=js"
export * from "./MagazinePuzzles.vue?vue&type=script&lang=js"
import style0 from "./MagazinePuzzles.vue?vue&type=style&index=0&id=71295a7c&prod&lang=scss"
import style1 from "./MagazinePuzzles.vue?vue&type=style&index=1&id=71295a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71295a7c",
  null
  
)

export default component.exports